import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class MyDocReviewService {

  constructor(private httpClient: HttpClient) { }

  getMyDocReviews(isInactive: boolean): Observable<any> {
    return this.httpClient.get(ApiConstants.DocumentMyReview_Api+"/"+isInactive);
  }
}
